import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import bgimg from '../images/getintouch-bg2.webp'
import './getintouch2.css';


const Getintouch2 = ({setBlank}) => {

    let { id } = useParams();  


    const scrollToTop = () => {
        setBlank(true);
        setTimeout(() => {
        window.scrollTo(0, 0);
        }, 100);
        setTimeout(() => {
        setBlank(false);            
        }, 600);
    }
    
    return (
        <>
        {/* style={{ backgroundImage: `url(${bgimg})` }} */}
        {/* {id !== "" ? brandlogo : brandlogo }  */}
        {/* {id !== "" ? { backgroundImage: `url(${bgimg})` } : brandlogo }  */}
        
            <section className='getint2-section desktop' style={{ backgroundImage: `url(${id !== "" ? bgimg : bgimg })` }}>
                <Container>
                    <Row className='w-100'>
                        <Col className='col-md-6'>
                            <div className='content-box'>
                                <div className="h3">Get </div>
                                <div className="strok">In Touch</div>
                                <div className="h1 anima">In<span className='anima-underline' >Touch</span></div>
                            </div>
                        </Col>
                        <Col className='col-md-6'>
                            <div className='text-right'>
                               <NavLink to="/contact" onClick={scrollToTop}><button className="findout-btn mt-5 mx-auto">Talk to our experts</button></NavLink>
                               
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* style={{ backgroundImage: `url(${id !== "" ? bgimg : bgimg })` }} */}
            <section className='getint2-section mobile' style={{ backgroundImage: `url(${id !== "" ? bgimg : bgimg })` }}>
                <Container>
                    <Row>
                        <div className='content-box'>
                            <div className="h3">Get</div>
                            <div className="strok">In Touch</div>
                            <div className="h1 anima">In <span className='anima-underline' > Touch</span></div>
                        </div>
                    </Row>

                </Container>
                <Container>
                    <Row>
                        <div className=''>
                        <NavLink to="/contact" onClick={scrollToTop}> <button className="findout-btn">Talk to our experts</button></NavLink>
                        </div>
                    </Row>
                </Container>

            </section>
        </>

    )
}

export default Getintouch2